import { Component, Input, OnInit } from '@angular/core';
import { ToastController, NavController, PopoverController } from '@ionic/angular';
import { RaffleStatus } from 'src/app/data/schema/raffle';
import { RaffleService } from 'src/app/data/service/raffle.service';
import { RaffleSummaryPage } from 'src/app/modules/admin/modal/raffle-summary/raffle-summary.page';
import { RaffleBasePage } from '../../raffle-base-page';
import { MissingStepsPopoverComponent } from '../missing-steps-popover/missing-steps-popover.component';
import { ServiceHelper } from 'src/app/core/helper/services.helper';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/modules/auth-core/data/service/authentication.service';

@Component({
  selector: 'app-setup-header',
  templateUrl: './setup-header.component.html',
  styleUrls: ['./setup-header.component.scss'],
})
export class SetupHeaderComponent extends RaffleBasePage implements OnInit {

  @Input() goLiveId: string;
  @Input() showGoLive = true;

  raffleLink = '';
  goLiveIncomplete = false;
  isAdmin = false;


  constructor(
    protected raffleService: RaffleService,
    protected toastCtrl: ToastController,
    protected navCtrl: NavController,
    private popoverCtrl: PopoverController,
    private router: Router,
    authService: AuthenticationService
  ) {
    super(raffleService, authService);

    raffleService.raffleUpdated.subscribe(() => {
      this.canGoLive();
    });
  }

  get isBankingPage() { return this.router.url.endsWith('banking'); }


  ngOnInit() {
    this.loadData();
  }

  routeToBanking() {
    this.navCtrl.navigateForward(`/admin/${this.raffle.accessCode}/setup/banking`);
  }

  routeToMessages() {
    this.navCtrl.navigateForward(`/admin/${this.raffle.accessCode}/messages`);
  }

  showStripeError() {
    ServiceHelper.displayAlert('Banking setup not complete', 'Please complete your banking setup to continue.');
  }

  async requestChanges() {
    // confirm the action
    const hasConfirmed = await this.confirmSomething('Confirm Request for Changes', 'Are you sure you want to cancel the review of your raffle?');
    if (!hasConfirmed) {
      return;
    }
    
    // set the status back to draft then save it
    this.raffle.status = RaffleStatus.Draft;
    this.raffle.rejectReason = null; // ensure we don't set a reject reason otherwise the API might send it
    const didSave = await this.save();
    if (!didSave) {
      this.raffle.status = RaffleStatus.Pending;
    } else {
      ServiceHelper.displayAlert('Withdrawn', 'Your raffle has been withdrawn from review. You can now make any modifications you require.');
    }
  }

  canGoLive() {
    this.goLiveIncomplete = (
      !this.detailsValid ||
      !this.organizationValid ||
      !this.aboutRaffleValid ||
      !this.ticketValid ||
      !this.prizesValid ||
      !this.bankingValid ||
      !this.licenseValid);
  }

  async goLive(evt) {
    this.canGoLive();
    if (this.goLiveIncomplete === true) {
      const popover = await this.popoverCtrl.create({
        component: MissingStepsPopoverComponent,
        translucent: true,
        cssClass: 'custom-popover',
        event: evt
      });
      await popover.present();
    } else {
      const raffSummaryModal = await ServiceHelper.modalCtrl.create({
        component: RaffleSummaryPage,
        backdropDismiss: false
      });
      await raffSummaryModal.present();
    }
  }

  // Print & Social Segment Functions
  async copyLink() {
    navigator.clipboard.writeText(this.raffleLink);
    (await this.toastCtrl.create({ message: `Link copied!`, position: 'top', duration: 1000 })).present();
  }

  protected async loadData() {
    await super.loadData();

  //  setInterval(() => {
      this.canGoLive();
  //  }, 1000);

    // raffle link
    this.raffleLink = this.raffle.url;

    this.isAdmin = location.href.includes('l57admin');
  }
}
